import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { initialiseAdManager, displayAds, removeAds } from 'ducks/ads';

export class Ads extends React.Component {
  static propTypes = {
    adsInitialised: PropTypes.bool.isRequired,
    initialiseAdManager: PropTypes.func.isRequired,
    displayAds: PropTypes.func.isRequired,
    removeAds: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired
  };

  constructor(props) {
    super(props);
    const { adsInitialised, initialiseAdManager } = props;

    if (!adsInitialised) {
      initialiseAdManager();
    }
  }

  componentDidMount() {
    const { displayAds } = this.props;
    displayAds();
  }

  componentWillUnmount() {
    const { removeAds } = this.props;
    removeAds();
  }

  render() {
    const { children } = this.props;

    return <React.Fragment>{children}</React.Fragment>;
  }
}

const mapStateToProps = state => ({
  adsInitialised: state.ads.initialised
});

const mapDispatchToProps = {
  initialiseAdManager,
  displayAds,
  removeAds
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Ads);



// WEBPACK FOOTER //
// ./src/components/Ads/Ads.js